import React, { memo, forwardRef } from "react";
const SvgAlphabetA = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M17.62 16.44c-.387 0-.793.02-1.22.06-.427.027-.82.1-1.18.22-.36.107-.66.267-.9.48-.24.2-.36.48-.36.84 0 .227.047.42.14.58.107.147.24.267.4.36.16.093.34.16.54.2.2.04.4.06.6.06.827 0 1.453-.22 1.88-.66.427-.44.64-1.04.64-1.8v-.34h-.54zm2.82 3.3c0 .267-.04.487-.12.66-.08.16-.18.287-.3.38a.906.906 0 01-.38.18c-.12.027-.227.04-.32.04s-.207-.013-.34-.04a.915.915 0 01-.36-.18c-.12-.093-.22-.22-.3-.38a1.578 1.578 0 01-.12-.66v-.14h-.06c-.24.427-.627.78-1.16 1.06-.533.267-1.14.4-1.82.4a5.03 5.03 0 01-1.22-.16 3.683 3.683 0 01-1.16-.48 3.223 3.223 0 01-.88-.92c-.227-.387-.34-.86-.34-1.42 0-.72.2-1.293.6-1.72.413-.427.94-.753 1.58-.98a8.528 8.528 0 012.12-.44c.787-.08 1.553-.12 2.3-.12v-.24c0-.6-.22-1.04-.66-1.32-.427-.293-.94-.44-1.54-.44-.373 0-.727.067-1.06.2a6.7 6.7 0 00-1.02.52c-.227.133-.44.2-.64.2a.87.87 0 01-.64-.26.894.894 0 01-.26-.66c0-.147.033-.3.1-.46.08-.16.233-.313.46-.46a5.28 5.28 0 011.52-.7c.56-.173 1.14-.26 1.74-.26.853 0 1.553.12 2.1.36.56.24 1 .553 1.32.94.32.387.54.82.66 1.3.133.48.2.96.2 1.44v4.76z"
      />
    </svg>
  );
});
SvgAlphabetA.displayName = "SvgAlphabetA";
const MemoForwardRef = memo(SvgAlphabetA);
export default MemoForwardRef;
